// Entrypoint for server-rendered (ERB) and Hotwire pages: Turbo and Stimulus
// only. React and Inertia load from inertia.tsx, on Inertia pages alone, so an
// ERB page never downloads the React bundle (AGENTS.md section 4).
import * as Turbo from "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"

Turbo.start()

const stimulusApp = Application.start()
stimulusApp.debug = false

// Optional global access for debugging in development
declare global {
  interface Window {
    Stimulus: typeof stimulusApp
  }
}
window.Stimulus = stimulusApp
